var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"like-button",on:{"click":_vm.onClick}},[_c('span',{staticClass:"like-types"},[_vm._v(_vm._s(_vm.likesIcons))]),_c('span',{staticClass:"like-count"},[_vm._v(_vm._s(_vm.likes.length))]),(_vm.showLabel)?_c('span',[_vm._v(_vm._s(_vm.$tc('post.likePost.likes', _vm.likes.length)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }